export default {
  setSetting(state, data) {
    state.setting = data;
  },

  setProvinces(state, data) {
    state.provinces = data;
  },
  setProvinceCode(state, data) {
    state.provinceCode = data;
  },

  setCities(state, data) {
    state.cities = data;
  },
  setCityCode(state, data) {
    state.cityCode = data;
  },

  setActivityGroups(state, data) {
    state.activityGroups = data;
  },
  setActivityGroupCode(state, data) {
    state.activityGroupCode = data;
  },

  setInternalUnits(state, data) {
    state.internalUnits = data;
  },
  setInternalUnitCode(state, data) {
    state.internalUnitCode = data;
  },

  setAutomationTypes(state, data) {
    state.automationTypes = data;
  },
  setAutomationTypeCode(state, data) {
    state.automationTypeCode = data;
  },

  setVehicles(state, data) {
    state.vehicles = data;
  },
  setVehicleCode(state, data) {
    state.vehicleCode = data;
  },

  setBillboards(state, data) {
    state.billboards = data;
  },
  setBillboard(state, data) {
    state.billboard = data;
  },
  setBillboardCode(state, data) {
    state.billboardCode = data;
  },

  setServiceTypes(state, data) {
    state.serviceTypes = data;
  },
  setServiceTypeCode(state, data) {
    state.serviceTypeCode = data;
  },

  setTariffs(state, data) {
    state.tariffs = data;
  },
  setTariff(state, data) {
    state.tariff = data;
  },
  setTariffCode(state, data) {
    state.tariffCode = data;
  },

  setWaterBillPeriods(state, data) {
    state.waterBillPeriods = data;
  },
  setWaterBillPeriodCode(state, data) {
    state.waterBillPeriodCode = data;
  },
  setWaterBillPeriodCheck(state, data) {
    state.waterBillPeriodCheck = data;
  },

  setNotices(state, data) {
    state.notices = data;
  },
  setNotice(state, data) {
    state.notice = data;
  },
  setNoticeCode(state, data) {
    state.noticeCode = data;
  },

  setSubscribers(state, data) {
    state.subscribers = data;
  },
  setSubscriber(state, data) {
    state.subscriber = data;
  },

  setTransactionInfos(state, data) {
    state.transactionInfos = data;
  },

};
